import { Stack } from 'src/design/atoms/Stack';
import React from 'react';
import { useAdminStatsByUser } from 'src/api/queries/chatAdmin/useAdminStatsQueries';
import { AdminStatsSections } from 'src/routes/Settings/AIAssistant/components/AdminStatsSections';
import { DateRangeFilter } from 'src/routes/Settings/AIAssistant/components/DateRangeFilter';
import { TopUsersTable } from 'src/routes/Settings/AIAssistant/components/TopUsersTable';
import { useAdminStats } from 'src/routes/Settings/AIAssistant/hooks/useAdminStats';
import { useDefaultDateRange } from 'src/routes/Settings/AIAssistant/hooks/useDefaultDateRange';

export const OverviewTab: React.FC = () => {
  const [dateRange, setDateRange] = useDefaultDateRange();
  const { overview, daily, loading } = useAdminStats(undefined, dateRange);

  const [from, to] = dateRange;
  const topUsersQuery = useAdminStatsByUser(from, to);

  return (
    <Stack gap="md">
      <DateRangeFilter value={dateRange} onChange={setDateRange} />
      <AdminStatsSections
        overview={overview}
        daily={daily}
        loading={loading}
        dateRange={dateRange}
      />
      <TopUsersTable
        users={topUsersQuery.data ?? []}
        loading={topUsersQuery.isLoading}
      />
    </Stack>
  );
};
